import type { NotificationStatusValue } from '../../services/firestore/firestoreTypes'

export type BrowserNotificationLike = {
  permission: NotificationPermission
}

export function notificationStatusFromPermission(permission: NotificationPermission): NotificationStatusValue {
  if (permission === 'granted') return 'enabled'
  if (permission === 'denied') return 'denied'
  return 'unknown'
}

export function getBrowserNotificationStatus(notificationApi: BrowserNotificationLike | undefined): NotificationStatusValue {
  if (!notificationApi) return 'unsupported'
  return notificationStatusFromPermission(notificationApi.permission)
}

export function shouldShowNotificationReminder(input: { role: string | null; status: NotificationStatusValue }): boolean {
  if (input.role !== 'admin' && input.role !== 'parent' && input.role !== 'employee') return false
  return input.status !== 'enabled'
}

export function shouldShowDeviceNotificationOnboarding(input: {
  role: string | null
  deviceStatus: NotificationStatusValue | undefined
  browserStatus: NotificationStatusValue
}): boolean {
  if (input.role !== 'admin' && input.role !== 'parent' && input.role !== 'employee') return false
  if (input.browserStatus === 'denied' || input.browserStatus === 'unsupported') return false
  if (input.deviceStatus === 'enabled' || input.deviceStatus === 'skipped' || input.deviceStatus === 'unsupported') return false
  // A previously denied device may be retried after the browser permission is reset to granted.
  return input.deviceStatus !== 'denied' || input.browserStatus === 'enabled'
}
